/* eslint react/jsx-indent: 1 */
/* eslint react/jsx-indent-props: 1 */

import React from 'react';
import moment from 'moment';
import { PrimaryButton, Modal, Tooltip } from 'wf-react-component-library';
import currencyFormatter from '../utilities/currency-formatter';

import './PurchaseOrderItemDetails.scss';

// const logger = new Logger('PurchaseOrderItemDetails.js');

const P3_TOOLTIP_MSG = 'P3 currently at';

class PurchaseOrderItemDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showToolTip: false,
      approveMsg:'',
      rejectMsg:'',
    };

    this.formatDate = this.formatDate.bind(this);
    this.showTooltip = this.showTooltip.bind(this);
    this.hideTooltip = this.hideTooltip.bind(this);
    this.compareHeaders = this.compareHeaders.bind(this);
    this.showApproveMsg = this.showApproveMsg.bind(this);
    this.showRejectMsg = this.showRejectMsg.bind(this);
    this.clearConfirmationMsg = this.clearConfirmationMsg.bind(this);
    this.handleNoteChange = this.handleNoteChange.bind(this);
  }

  formatDate = (myDt) => {
    const dt = moment(myDt);
    return dt.format('MM/DD/YYYY');
  }

  showTooltip = () => {
    this.setState({ showToolTip: true });
  }

  hideTooltip = () => {
    this.setState({ showToolTip: false });
  }

  handleNoteChange = (e) => {
    const buyerNote = e.target.value.length > 0 ? e.target.value : null;
    this.setState({ buyerNote: buyerNote });
  }

  compareHeaders = () => {
    const { purchaseOrderDetails, orderHeaders } = this.props;
    if (orderHeaders && orderHeaders.totalCartons && orderHeaders.totalCost && orderHeaders.totalPallets) {
      return (
        purchaseOrderDetails.calculatedCases !== orderHeaders.totalCartons
          || purchaseOrderDetails.calculatedCost !== orderHeaders.totalCost
          || purchaseOrderDetails.calculatedPallets.toFixed(2) !== orderHeaders.totalPallets.toFixed(2)
      );
    }
    return false;
  }

  showApproveMsg = () => {        
        this.approveMsg = 'Are you sure you want to Approve this XPO Confirmation? If you continue, the XPO will be updated and Booked in P3.';  
        this.rejectMsg = '';
        this.setState({ approveMsg : this.approveMsg });
        this.setState({ rejectMsg : this.rejectMsg });  
    }

  showRejectMsg = () => {
        this.rejectMsg = 'Are you sure you want to Reject this XPO Confirmation? If you continue, the XPO will not be Booked in P3.'; 
        this.approveMsg = '';
        this.setState({ rejectMsg : this.rejectMsg });  
        this.setState({ approveMsg : this.approveMsg }); 
    }

    clearConfirmationMsg = () => {
      this.rejectMsg = ''; 
      this.approveMsg = '';
      this.setState({ rejectMsg : this.rejectMsg });  
      this.setState({ approveMsg : this.approveMsg }); 
  }

  render() {
    const {
      purchaseOrderItemDetails,
      vendorName,
      poNumber,
      purchaseOrderDetails,
      orderValidations
    } = this.props;

    const { showToolTip, buyerNote } = this.state;
    const tooltipClassName = showToolTip === true ? 'tip active' : 'tip';
    const items = purchaseOrderItemDetails;
    return (
        <Modal show={purchaseOrderItemDetails !== null} width="90%">
            <div className="flex-container-row">
                <div className="flex-container-column ocd-item-header">
                    {vendorName}
                    {' '}
                    -
                    {' '}
                    {poNumber}
                    {' '}
                    Order Confirmation
                </div>
            </div>

            <div className="flex-container-row po-header-details">
                <div className="flex-container-column po-header-details">
                    Total Cases:
                    {' '}
                    {purchaseOrderDetails.calculatedCases}
                </div>
                <div className="flex-container-column po-header-details">
                    Total Price:
                    {' '}
                    {currencyFormatter.format(purchaseOrderDetails.calculatedCost)}
                </div>
                <div className="flex-container-column po-header-details">
                    Total Pallets:
                    {' '}
                    {purchaseOrderDetails.calculatedPallets.toFixed(2)}
                </div>
                
            </div>
            <div className="flex-container-row item-table-container show">
                <div className="flex-container-column">
                    <table className="item-table" cellPadding="0" cellSpacing="0" width="100%">
                        <colgroup>
                            <col span="1" style={{ width: '3%' }} />
                            <col span="1" style={{ width: '17%' }} />
                            <col span="1" style={{ width: '3%' }} />
                            <col span="1" style={{ width: '3%' }} />
                            <col span="1" style={{ width: '3%' }} />
                            <col span="1" style={{ width: '3%' }} />
                            <col span="1" style={{ width: '4%' }} />
                            <col span="1" style={{ width: '4%' }} />
                            <col span="1" style={{ width: '4%' }} />
                            <col span="1" style={{ width: '4%' }} />
                        </colgroup>
                        <tbody>
                            <tr className="item-table-header">
                                <td>Item Code</td>
                                <td>Description</td>
                                <td className="qty-color" style={{ paddingLeft: '0px !important' }}>Order Qty</td>
                                <td className="qty-color" style={{ paddingLeft: '0px !important' }}>New Qty</td>
                                <td className="location-color" style={{ paddingLeft: '0px !important' }}>COO</td>
                                <td className="location-color" style={{ paddingLeft: '0px !important' }}>New COO</td>
                                <td className="price-color">Buy Price</td>
                                <td className="price-color">New Price</td>
                                <td style={{ textAlign: 'center' }}>Pallets</td>
                            </tr>
                            {items.map((item) => {
                              const orderValidation = orderValidations.length > 0 ? orderValidations.find(order => order.poDetailId === item.poDetailId) : {};
                              const price = item.price ? currencyFormatter.format(item.price) : '';
                              const originalPrice = item.originalPrice ? currencyFormatter.format(item.originalPrice) : '';
                              const isBurdenItem = (item.groupCode === "M" || item.groupCode === "MB" || item.groupCode === "SB") ? true : false;
                              return (
                                    <tr key={item.poDetailId}>
                                        <td style={{ textAlign: 'left', paddingLeft: '5px' }}>{item.itemCode}</td>
                                            <td style={{ textAlign: 'left', paddingLeft: '5px' }}>{item.description}</td>
                                        <td className="qty-color">
                                            {orderValidation && orderValidation.originalQty && item.originalQty ? <span><Tooltip tooltip={`${P3_TOOLTIP_MSG} ${orderValidation.originalQty}`} tip={`${item.originalQty || ''}*`} tooltipClassName={tooltipClassName} onMouseEnter={this.showTooltip} onMouseLeave={this.hideTooltip} /></span> : item.originalQty}
                                        </td>
                                        <td className="qty-color">
                                            {parseInt(item.qty) === parseInt(item.originalQty) ? null : item.qty}
                                        </td>
                                        <td className="location-color">
                                            {isBurdenItem ? null : orderValidation && orderValidation.originalCountryOfOrigin && item.originalCountryOfOrigin ? <span><Tooltip tooltip={`${P3_TOOLTIP_MSG} ${orderValidation.originalCountryOfOrigin}`} tip={`${item.originalCountryOfOrigin || ''}*`} tooltipClassName={tooltipClassName} onMouseEnter={this.showTooltip} onMouseLeave={this.hideTooltip} /></span> : item.originalCountryOfOrigin}
                                        </td>
                                        <td className="location-color">
                                            {isBurdenItem ? null : (item.countryOfOrigin === item.originalCountryOfOrigin ? null : item.countryOfOrigin)}
                                        </td>
                                        <td className="price-color">
                                            {orderValidation && orderValidation.originalPrice && originalPrice ? <span><Tooltip tooltip={`${P3_TOOLTIP_MSG} ${currencyFormatter.format(orderValidation.originalPrice)}`} tip={`${originalPrice}*`} tooltipClassName={tooltipClassName} onMouseEnter={this.showTooltip} onMouseLeave={this.hideTooltip} /></span> : originalPrice}
                                        </td>
                                        <td className="price-color">
                                            {price === originalPrice ? null : price}
                                        </td>
                                        <td>
                                            {item.calculatedPallets.toFixed(2)}                                           
                                        </td>
                                    </tr>
                              );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
            
            <div className="flex-container-row po-note-container">
              <label htmlFor="note">Note:</label>
                <input id="note" type="text" className="po-note" onChange={ this.handleNoteChange } />
            </div>

            { 
              this.approveMsg ?
                <div className="confirmation-msg"> {this.approveMsg}
                  <button className="toggle-items" type="button" onClick={() => this.props.handleApprove(buyerNote)}> Continue </button>
                  <button className="toggle-items" type="button" onClick={this.clearConfirmationMsg}> Cancel </button>
                </div> : null 
            }

            {
              this.rejectMsg ?
                <div className="confirmation-msg"> {this.rejectMsg}
                  <button className="toggle-items" type="button" onClick={() => this.props.handleReject(buyerNote)}> Continue </button>
                  <button className="toggle-items" type="button" onClick={this.clearConfirmationMsg}> Cancel </button>
                </div> : null 
            } 
             

            <div className="flex-container-row buttons">
                <PrimaryButton onClick={this.showApproveMsg} name="Approve" />
                <PrimaryButton onClick={this.showRejectMsg} name="Reject" />
                <PrimaryButton onClick={this.props.closeModal} name="Close" />
            </div>

        </Modal>
    );
  }
}

export default PurchaseOrderItemDetails;
